export const emailButtonLabel = "gaL_xc";
export default {emailButtonLabel};